var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "16px",
    viewBox: "0 0 10 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C419ABE3-0BDD-4940-BB75-63E57B6C79FF") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livestream_landing",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livestream_Landing_streamon_nonexpand_Desktop",
    transform: "translate(-332.000000, -2190.000000)",
    fill: "#00095B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Widget-/-Map-/-Web",
    transform: "translate(0.000000, 1840.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Button",
    transform: "translate(112.000000, 338.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(49.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(171.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.1316437,0.108597285 C1.20250984,0.036199095 1.29699821,0 1.41510827,0 C1.53321832,0 1.63951754,0.036199095 1.73400591,0.108597285 L9.13951772,7.71040724 C9.23400609,7.78280543 9.28125,7.87933653 9.28125,8 C9.28125,8.12066347 9.23400609,8.21719457 9.13951772,8.28959276 L1.73400591,15.8914027 C1.63951754,15.9638009 1.53321832,16 1.41510827,16 C1.29699821,16 1.20250984,15.9638009 1.1316437,15.8914027 L0.422982283,15.1674208 C0.328493914,15.0950226 0.28125,14.9984915 0.28125,14.8778281 C0.28125,14.7571646 0.328493914,14.6485673 0.422982283,14.5520362 L6.83636811,8 L0.422982283,1.4479638 C0.328493914,1.3514327 0.28125,1.24283541 0.28125,1.12217195 C0.28125,1.00150848 0.328493914,0.904977376 0.422982283,0.832579186 L1.1316437,0.108597285 Z",
    id: "chevron-right"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.f1c915176b29edd118ebad414fcad2c7.svg";
export { ForwardRef as ReactComponent };